module.exports = __webpack_public_path__ + "media/assets/images/logo-vc-deaf6897e0ee7748fa11c5399e21ce6e.svg";